/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompleteDevicePlanChangeRequest
 */
export interface CompleteDevicePlanChangeRequest {
    /**
     * 
     * @type {string}
     * @memberof CompleteDevicePlanChangeRequest
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof CompleteDevicePlanChangeRequest
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof CompleteDevicePlanChangeRequest
     */
    notes?: string | null;
}

/**
 * Check if a given object implements the CompleteDevicePlanChangeRequest interface.
 */
export function instanceOfCompleteDevicePlanChangeRequest(value: object): value is CompleteDevicePlanChangeRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('success' in value) || value['success'] === undefined) return false;
    return true;
}

export function CompleteDevicePlanChangeRequestFromJSON(json: any): CompleteDevicePlanChangeRequest {
    return CompleteDevicePlanChangeRequestFromJSONTyped(json, false);
}

export function CompleteDevicePlanChangeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompleteDevicePlanChangeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'success': json['success'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function CompleteDevicePlanChangeRequestToJSON(json: any): CompleteDevicePlanChangeRequest {
    return CompleteDevicePlanChangeRequestToJSONTyped(json, false);
}

export function CompleteDevicePlanChangeRequestToJSONTyped(value?: CompleteDevicePlanChangeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'success': value['success'],
        'notes': value['notes'],
    };
}

